import { z } from 'zod';

export const WorkspaceSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const WorkspacesSchema = z.array(WorkspaceSchema);

export const WorkspacesResponseSchema = z.object({
  data: z.object({
    items: WorkspacesSchema,
    additional: z.null(),
    itemsPerPage: z.number().or(z.null()),
    totalItems: z.number().or(z.null()),
    message: z.string().or(z.null()),
    ordering: z.string().or(z.null()),
    pageNumber: z.number().or(z.null()),
  }),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;
